export const calculateSmartHrCost = (numberOfEmployees: number): number => {
  // 1-3 $15
  // 4-9 $25
  // 10-20 $35
  // 21-50 $50
  // 50+ $75

  if (numberOfEmployees <= 3) {
    return 15;
  }

  if (numberOfEmployees <= 9) {
    return 25;
  }

  if (numberOfEmployees <= 20) {
    return 35;
  }

  if (numberOfEmployees <= 50) {
    return 50;
  }

  // 50+ employees
  return 75;
};
